import {ValueObject} from '@s-ui/domain'

export class NewsTagsListValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Array} deps.items
   */

  getItems = () => this._items
}
